// 서비스 파일 구조

import { api } from "@/comn";
import { ptlEnvs } from "@/tra/tancis/ptli/comn";
import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { comnUtils } from "@/comn/utils";

/*
 * Customs Management service
 * !== 세관관리 서비스 ==!
 */

/*
 * @ BASE
 * @ 서비스에서 사용하는 기본 정보 세팅
 * @ path : 화면들의 기본 웹 경로
 * @ api : 사용하는 api 의 기본 주소
 * @ api 주소가 여러개일 경우 _ 로구분하여 의미에 맞게 카멜표기업으로 표시 : api_clr
 * @ nodes : 화면의 Page.Navigation 에서 사용하는 기본 결로 Array
 */
export const BASE = {
    path: `${ptlEnvs.base}/usr/cstm`,
    api: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/intptl/usr/cstm`,
    nodes: [
        { path: "/", label: "L_INT_PTL" },
        { path: "/", label: "L_PTL_MGMT" },
    ],
};

/*
 * @ URLS
 * @ 화면에서 사용하는 주소들 정의
 * @ 해당화면의 컴포넌트명 대문자로 정의
 */
export const URLS = {
    ptli0901001q: `${BASE.path}/ptli0901001q`, // Customs List !== 세관 목록 ==!
    ptli0901002s: `${BASE.path}/ptli0901002s`, // customs registration !== 세관 등록 ==!
    ptli0901003s: `${BASE.path}/ptli0901003s`, // Edit customs information !== 세관 정보 수정 ==!
    ptli0901004q: `${BASE.path}/ptli0901004q`, // Customs details !== 세관 상세 정보 ==!
};

/*
 * @ APIS
 * @ 화면에서 사용하는 api 정의
 */
export const APIS = {
    // Customs List Inquiry !== 세관 목록 조회 ==!
    getCstmList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    // Customs details inquiry !== 세관 상세 정보 조회 ==!
    getCstmInfo: (cstmOfceCd: any) => {
        return api.get(`${BASE.api}/${cstmOfceCd}`);
    },
    // Save customs information !== 세관 정보 저장 ==!
    saveCstm: (data: any) => {
        return api.post(`${BASE.api}`, {
            ...data,
        });
    },
    deleteCstm: (cstmOfceCd: any) => {
        return api.delete(`${BASE.api}/${cstmOfceCd}`);
    },
};

export const SF_CSTM_SRCH: TFormSchema = {
    id: "form_CstmSrch",
    schema: {
        cstmOfceCd: { type: "text", label: "L_CSTM_CD" },
        cstmNm: { type: "text", label: "L_CSTM_NM" },
        cstmTpCd: {
            type: "checkbox",
            label: "L_CSTM_TP_CD",
            area: "comnCd",
            comnCd: "COM0016",
            excludes: ["0", "SA", "SL"],
        },
    },
};

export const SG_CSTM_LIST: TGridSchema = {
    id: "grid_CstmList",
    options: { pagination: "out", index: true },
    head: [
        { cells: [{ header: "L_CSTM_CD", binding: "cstmOfceCd", width: "10%" }] },
        { cells: [{ header: "L_CSTM_TP_NM", binding: "coTpCdNm", width: "15%" }] },
        { cells: [{ header: "L_CSTM_NM", binding: "cstmNm", width: "20%" }] },
        { cells: [{ header: "L_CSTM_ADDR", binding: "cstmAddr", width: "30%" }] },
        { cells: [{ header: "L_CSTM_DESC", binding: "cstmDesc", width: "*" }] },
    ],
    body: [
        { cells: [{ binding: "cstmOfceCd", edit: false }] },
        {
            cells: [{ binding: "cstmTpCdNm", align: "left" }],
        },
        { cells: [{ binding: "cstmNm", edit: false, align: "left" }] },
        {
            cells: [{ binding: "cstmAddr", align: "left" }],
        },
        {
            cells: [{ binding: "cstmDesc", align: "left" }],
        },
    ],
};

export const SF_CSTM_INFO: TFormSchema = {
    id: "form_CstmInfo",
    schema: {
        cstmOfceCd: { type: "text", label: "L_CSTM_CD", required: true, maxLength: 5 },
        cstmEnNm: { type: "text", label: "L_CSTM_TZ_NM", required: true },
        cstmTzNm: { type: "text", label: "L_CSTM_EN_NM", required: true },
        cstmKoNm: { type: "text", label: "L_CSTM_KO_NM", required: true },
        cstmAddr: { type: "text", label: "L_CSTM_ADDR" },
        cstmTelno: { type: "text", label: "L_CSTM_TELNO" },
        cstmFaxNo: { type: "text", label: "L_CSTM_FAX_NO" },
        cstmTlxNo: { type: "text", label: "L_CSTM_TLX_NO" },
        scnrYn: {
            type: "select",
            label: "L_CSTM_SCNR_YN",
            required: true,
            options: [
                { label: "YES", value: "Y" },
                { label: "NO", value: "N" },
            ],
        },
        dclrYn: {
            type: "select",
            label: "L_CSTM_DELR_YN",
            required: true,
            options: [
                { label: "YES", value: "Y" },
                { label: "NO", value: "N" },
            ],
        },
        cstmTpCd: {
            type: "checkbox",
            label: "L_CSTM_TP",
            area: "comnCd",
            comnCd: "COM0016",
            required: true,
            excludes: ["0", "SA", "SL"],
        },
        regnTpCd: { type: "select", label: "L_CSTM_REGN_TP", area: "comnCd", comnCd: "CLR0064" },
        regnCd: { type: "select", label: "L_CSTM_REGN", area: "comnCd", comnCd: "COM0019", required: true },
        cstmDesc: { type: "textarea", label: "L_CSTM_DESC", controlSize: 10, rows: 5 },
    },
};
